import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Skeleton } from '@mui/material';

const LocationSkeleton = ({ height }) => (
  <>
    <Box display="flex" flexDirection="column" height={height} p={3} width="100%">
      <Box mb={1}>
        <Skeleton borderradius={1} height={25} mb={3} variant="rectangular" width="75%" />
      </Box>
      <Box display="flex">
        <Box mb={1} mr={2}>
          <Skeleton borderradius={2} height={20} variant="rectangular" width={25} />
        </Box>
        <Skeleton borderradius={1} height={20} variant="text" width="75%" />
      </Box>
      <Box display="flex">
        <Box mr={2}>
          <Skeleton borderradius={2} height={20} variant="rectangular" width={25} />
        </Box>
        <Skeleton borderradius={1} height={20} variant="text" width="75%" />
      </Box>
    </Box>
    <Divider />
  </>
);

LocationSkeleton.propTypes = {
  height: PropTypes.number,
};
LocationSkeleton.defaultProps = {
  height: 129,
};

export default LocationSkeleton;
